<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">

        <div class="form container px-2">

        <h5 class="mb-3"><b>C. PUBLICATIONS AND OTHER PRODUCTIVE WORKS</b></h5>

        <div class="mb-4 text-start">
            <!--Books-->
            <div>
                <b>
                    C.1 &nbsp; &nbsp;Research books (in main discipline):
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#books"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=books :type='"books"' />
        </div>

        <!-- books Modal -->
        <div class="modal fade" id="books" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Books in Discipline</h1>
                        <button id="closeBooks" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="booktitle" class="form-label">Book Details:</label>
                            <span>
                                <textarea rows="4" v-model="book" type="text" class="form-control"
                                    id="booktitle" placeholder="e.g. Nkakini, S.O., Orji, C.U., Chuku, A.J., Le-ol, A.K., Jinyemiema, T.K., Eke, E.C., Wofuru-Nyenke, O.K. (2023). A Textbook of Applied Mechanics. Impress Prints Technologies, Port Harcourt, Nigeria. ISBN: 978-978-981-062-8"></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="bookUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="bookUrl" type="text" class="form-control" id="bookUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('book')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--major productive works-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    C.2 &nbsp; &nbsp;Major other productive works:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#majorWork"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=majorWorks :type="'majorWorks'" />
        </div>

        <!-- major work Modal -->
        <div class="modal fade" id="majorWork" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Major Productive Work</h1>
                        <button id="closeMajorWorks" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="booktitle" class="form-label">Describe major productive work:</label>
                            <span>
                                <textarea rows="4" v-model="majorWork" type="text" class="form-control"
                                    id="majorWork" placeholder="e.g. Design and construction of a Portable Manual Tyre Changer."></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="majorWorkUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="majorWorkUrl" type="text" class="form-control" id="majorWorkUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('majorWork')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--minor productive works-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    C.3 &nbsp; &nbsp;Minor other productive works:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#minorWork"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=minorWorks :type="'minorWorks'" />
        </div>

        <!-- minor work Modal -->
        <div class="modal fade" id="minorWork" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Minor Productive Work</h1>
                        <button id="closeMinorWorks" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="booktitle" class="form-label">Describe minor productive work:</label>
                            <span>
                                <textarea rows="4" v-model="minorWork" type="text" class="form-control"
                                    id="minorWork" placeholder="e.g. Design and construction of a Portable Manual Tyre Changer."></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="minorWorkUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="minorWorkUrl" type="text" class="form-control" id="minorWorkUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('minorWork')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--book chapters-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    C.4 &nbsp; &nbsp;Chapters in research books:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#bookChapter"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=bookChapters :type="'bookChapters'" />
        </div>

        <!-- book chapters Modal -->
        <div class="modal fade" id="bookChapter" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="bookChapterLabel">Chapters in Research Books</h1>
                        <button id="closeBookChapters" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="bookChapter" class="form-label">Details of research book chapter:</label>
                            <span>
                                <textarea rows="4" v-model="bookChapter" type="text" class="form-control"
                                    id="bookChapterText" placeholder="e.g. Nkakini, S.O., Orji, C.U., Chuku, A.J., Le-ol, A.K., Jinyemiema, T.K., Eke, E.C., Wofuru-Nyenke, O.K. (2023). A Textbook of Applied Mechanics. Impress Prints Technologies, Port Harcourt, Nigeria. ISBN: 978-978-981-062-8"></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="bookChapterUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="bookChapterUrl" type="text" class="form-control" id="bookChapterUrl" placeholder="https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('bookChapter')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--journal articles-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    C.5 &nbsp; &nbsp;Refereed Published Journal Papers:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#journalArticle"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=journalArticles :type="'journalArticles'" @toggleLoader="toggleLoader" />
        </div>

        <!-- journal articles modal -->
        <div class="modal fade" id="journalArticle" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="journalArticleLabel">Published Journal Papers</h1>
                        <button id="closeJournals" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="bookChapter" class="form-label">Details of Journal Article:</label>
                            <span>
                                <textarea rows="4" v-model="journalArticle" type="text" class="form-control"
                                    id="journalArticleText" placeholder="e.g. Wofuru-Nyenke, O.K., Nkoi, B. & Oparadike, F.E. (2019). Waste and Cost Reduction for a Water Bottling Process Using Lean Six Sigma. European Journal of Engineering and Technology Research, 4(12), 71 – 77."></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="journalArticleUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="journalArticleUrl" type="text" class="form-control" id="journalArticleUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('journalArticle')" type="button"
                            class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--conference articles-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    C.6 &nbsp; &nbsp;Refereed Published Conference Papers:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#conferenceArticle"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=conferenceArticles :type="'conferenceArticles'" @toggleLoader="toggleLoader"  />
        </div>

        <!-- conference articles modal -->
        <div class="modal fade" id="conferenceArticle" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="conferenceArticleLabel">Published Conference Papers</h1>
                        <button id="closeConferences" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="conferenceArticle" class="form-label">Details of Conference Article:</label>
                            <span>
                                <textarea rows="4" v-model="conferenceArticle" type="text" class="form-control"
                                    id="conferenceArticleText" placeholder="e.g. Wofuru-Nyenke, O.K. (2025). The Optimising Known Warehouses (OKW) Framework for Supply Chain Optimisation presented at the 2025 Rivers State University Postgraduate International Annual Conference on the theme: Interdisciplinary Innovations: Bridging Knowledge for a Sustainable Future, Rivers State University, Port Harcourt, Nigeria, 6th – 9th October, 2025."></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="conferenceArticleUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="conferenceArticleUrl" type="text" class="form-control" id="conferenceArticleUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('conferenceArticle')" type="button"
                            class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--technical report-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    C.7 &nbsp; &nbsp;Technical Reports/Monographs:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#technicalReport"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=technicalReports :type="'technicalReports'" />
        </div>

        <!-- technical report modal -->
        <div class="modal fade" id="technicalReport" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="technicalReportLabel">Technical Report or Monograph</h1>
                        <button id="closeReports" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="bookChapter" class="form-label">Details of Report or Monograph:</label>
                            <span>
                                <textarea rows="4" v-model="technicalReport" type="text" class="form-control"
                                    id="technicalReportText" placeholder="e.g. Smith, J. R. (2023). Analysis of Solar Panel Efficiency (Report No. TR-2023-01). Renewable Energy Institute. "></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="technicalReportUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="technicalReportUrl" type="text" class="form-control" id="technicalReportUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('technicalReport')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--book editor-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    C.8 &nbsp; &nbsp;Editorship of research books/journals:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#bookEditor"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=bookEditors :type="'bookEditors'" />
        </div>

        <!-- book editor modal -->
        <div class="modal fade" id="bookEditor" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="bookEditorLabel">Editorship of research books</h1>
                        <button id="closeEditor" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="bookChapter" class="form-label">Details of Book Editorship:</label>
                            <span>
                                <textarea rows="4" v-model="bookEditor" type="text" class="form-control"
                                    id="bookEditorText" placeholder="e.g. Nkakini, S.O., Orji, C.U., Chuku, A.J., Le-ol, A.K., Jinyemiema, T.K., Eke, E.C., Wofuru-Nyenke, O.K. (2023). A Textbook of Applied Mechanics. Impress Prints Technologies, Port Harcourt, Nigeria. ISBN: 978-978-981-062-8"></textarea>
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('bookEditor')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--other books-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    C.9 &nbsp; &nbsp;Other books in your discipline:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#otherBook"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=otherBooks :type="'otherBooks'" />
        </div>

        <!-- other books modal -->
        <div class="modal fade" id="otherBook" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="otherBookLabel">Other Books in Discipline</h1>
                        <button id="closeOtherBooks" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="otherBook" class="form-label">Details of Other Book:</label>
                            <span>
                                <textarea rows="4" v-model="otherBook" type="text" class="form-control"
                                    id="otherBookText" placeholder="e.g. Nkakini, S.O., Orji, C.U., Chuku, A.J., Le-ol, A.K., Jinyemiema, T.K., Eke, E.C., Wofuru-Nyenke, O.K. (2023). A Textbook of Applied Mechanics. Impress Prints Technologies, Port Harcourt, Nigeria. ISBN: 978-978-981-062-8"></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="otherBookUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="otherBookUrl" type="text" class="form-control" id="otherBookUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('otherBook')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="d-flex flex-row-reverse my-5">
            <button @click="submit()" type="button" class="btn btn-success">Submit</button>
            <button @click="saveSection('next')" type="button" class="btn btn-success me-3">Save</button>
            <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionC',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return { candidate: '',
            journalAdding: false,
            conferenceAdding: false,
            journalDeleting: false,
            conferenceDeleting: false,
            book: '',
            bookUrl: '',
            books: [],
            majorWork: '',
            majorWorkUrl: '',
            majorWorks: [],
            minorWork: '',
            minorWorkUrl: '',
            minorWorks: [],
            bookChapter: '',
            bookChapterUrl: '',
            bookChapters: [],
            journalArticle: '',
            journalArticleUrl: '',
            journalArticles: [],
            conferenceArticle: '',
            conferenceArticleUrl: '',
            conferenceArticles: [],
            technicalReport: '',
            technicalReportUrl: '',
            technicalReports: [],
            bookEditor: '',
            bookEditors: [],
            otherBook: '',
            otherBookUrl: '',
            otherBooks: [],
            journalReview: '',
            journalReviews: [],
            itemToDelete: '',
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section C');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.books.length; i++) {
                this.books[i].editing = false
            }
            for (var i=0; i < this.majorWorks.length; i++) {
                this.majorWorks[i].editing = false
            }
            for (var i=0; i < this.minorWorks.length; i++) {
                this.minorWorks[i].editing = false
            }
            for (var i=0; i < this.bookChapters.length; i++) {
                this.bookChapters[i].editing = false
            }
            for (var i=0; i < this.journalArticles.length; i++) {
                this.journalArticles[i].editing = false
            }
            for (var i=0; i < this.conferenceArticles.length; i++) {
                this.conferenceArticles[i].editing = false
            }
            for (var i=0; i < this.technicalReports.length; i++) {
                this.technicalReports[i].editing = false
            }
            for (var i=0; i < this.bookEditors.length; i++) {
                this.bookEditors[i].editing = false
            }
            for (var i=0; i < this.otherBooks.length; i++) {
                this.otherBooks[i].editing = false
            }
            for (var i=0; i < this.journalReviews.length; i++) {
                this.journalReviews[i].editing = false
            }
        },
        //joinDetails adds items to arrays based on category and also uploads journal and conference
        //articles when the add button is pressed
        async joinDetails(category) {
            this.$emit('toggleLoader');

            if (category == 'book') {
                if (this.book) {
                    this.books.unshift({ data: this.book, fileUrl: !/^https?:\/\//i.test(this.bookUrl) ? this.bookUrl ? "https://" + this.bookUrl : '' : this.bookUrl, score: 0 });
                    document.getElementById('closeBooks').click();
                } else {
                    alert('Fill book details')
                }
                this.book = '';
                this.bookUrl = '';
            } else if (category == 'majorWork') {
                if (this.majorWork) {
                    this.majorWorks.unshift({ data: this.majorWork, fileUrl: !/^https?:\/\//i.test(this.majorWorkUrl) ? this.majorWorkUrl ? "https://" + this.majorWorkUrl : '' : this.majorWorkUrl, score: 0 });
                    document.getElementById('closeMajorWorks').click();
                } else {
                    alert('Fill major work details')
                }
                
                this.majorWork = '';
                this.majorWorkUrl = '';
            } else if (category == 'minorWork') {
                if (this.minorWork) {
                    this.minorWorks.unshift({ data: this.minorWork, fileUrl: !/^https?:\/\//i.test(this.minorWorkUrl) ? this.minorWorkUrl ? "https://" + this.minorWorkUrl : '' : this.minorWorkUrl, score: 0 });
                    document.getElementById('closeMinorWorks').click();
                } else {
                    alert('Fill minor work details')
                }
                
                this.minorWork = '';
                this.minorWorkUrl = '';
            } else if (category == 'bookChapter') {
                if (this.bookChapter) {
                    this.bookChapters.unshift({ data: this.bookChapter, fileUrl: !/^https?:\/\//i.test(this.bookChapterUrl) ? this.bookChapterUrl ? "https://" + this.bookChapterUrl : '' : this.bookChapterUrl, score: 0 });
                    document.getElementById('closeBookChapters').click();
                } else {
                    alert('Fill book chapter details')
                }
                
                this.bookChapter = '';
                this.bookChapterUrl = '';
            } else if (category == 'journalArticle') {
                if (this.journalArticle) {
                    this.journalArticles.unshift({ data: this.journalArticle, fileUrl: !/^https?:\/\//i.test(this.journalArticleUrl) ? this.journalArticleUrl ? "https://" + this.journalArticleUrl : '' : this.journalArticleUrl, score: 0 });
                    document.getElementById('closeJournals').click();
                } else {
                    alert('Fill journal article details')
                }
                
                this.journalArticle = '';
                this.journalArticleUrl = '';
            } else if (category == 'conferenceArticle') {
                if (this.conferenceArticle) {
                    this.conferenceArticles.unshift({ data: this.conferenceArticle, fileUrl: !/^https?:\/\//i.test(this.conferenceArticleUrl) ? this.conferenceArticleUrl ? "https://" + this.conferenceArticleUrl : '' : this.conferenceArticleUrl, score: 0 });
                    document.getElementById('closeConferences').click();
                } else {
                    alert('Fill conference article details')
                }
                
                this.conferenceArticle = '';
                this.conferenceArticleUrl = '';
            } else if (category == 'technicalReport') {
                if (this.technicalReport) {
                    this.technicalReports.unshift({ data: this.technicalReport, fileUrl: !/^https?:\/\//i.test(this.technicalReportUrl) ? this.technicalReportUrl ? "https://" + this.technicalReportUrl : '' : this.technicalReportUrl, score: 0 });
                    document.getElementById('closeReports').click();
                } else {
                    alert('Fill technical report details')
                }
                
                this.technicalReport = '';
                this.technicalReportUrl = '';
            } else if (category == 'bookEditor') {
                if (this.bookEditor) {
                    this.bookEditors.unshift({ data: this.bookEditor, score: 0 });
                    document.getElementById('closeEditor').click();
                } else {
                    alert('Fill book editorship details')
                }
                
                this.bookEditor = '';
            } else if (category == 'otherBook') {
                if (this.otherBook) {
                    this.otherBooks.unshift({ data: this.otherBook, fileUrl: !/^https?:\/\//i.test(this.otherBookUrl) ? this.otherBookUrl ? "https://" + this.otherBookUrl : '' : this.otherBookUrl, score: 0 });
                    document.getElementById('closeOtherBooks').click();
                } else {
                    alert('Fill other books details')
                }
                
                this.otherBook = '';
                this.otherBookUrl = '';
            } else if (category == 'journalReview') {
                if (this.journalReview) {
                    this.journalReviews.unshift(this.journalReview);
                    document.getElementById('closeReviews').click();
                } else {
                    alert('Fill journal review details')
                }
                
                this.journalReview = '';
            }
            this.key += 1;
            this.$emit('toggleLoader');
        },
        toggleLoader(){
            this.$emit('toggleLoader');
        },
        async submit(){
            this.$emit('toggleLoader');

            const date = new Date();

            var dataDetails = {
                books: this.books,
                majorWorks: this.majorWorks,
                minorWorks: this.minorWorks,
                bookChapters: this.bookChapters,
                journalArticles: this.journalArticles,
                conferenceArticles: this.conferenceArticles,
                technicalReports: this.technicalReports,
                bookEditors: this.bookEditors,
                otherBooks: this.otherBooks,
                finalSubmitDate: date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear(),
                submitted: true,
            }

            const candidate = await DataService.saveData(dataDetails);

            if (candidate) {
                alert('You have successfully submitted your documents for appraisal');
                /*
                this.candidate = candidate;
                this.candidateId = candidate._id
                this.deanComments = candidate.deanComments ? candidate.deanComments.comment : '';
                this.deanEmail = candidate.deanEmail ? candidate.deanEmail : '';
                this.deanApproval = candidate.deanComments ? candidate.deanComments.approval : false;
                this.deanCommentDate = candidate.deanComments ? candidate.deanComments.date : '';
                this.submitToDeanDate = candidate.submitToDeanDate ? candidate.submitToDeanDate : '';
                this.finalSubmitDate = candidate.finalSubmitDate ? candidate.finalSubmitDate : '';
                */
                this.$emit('toggleLoader');
                this.$router.push({ path: `/sectiona` });
                return
            }

            this.$emit('toggleLoader');
        },
        async saveSection(page) {
            this.$emit('toggleLoader');

            var dataDetails = {
                books: this.books,
                majorWorks: this.majorWorks,
                minorWorks: this.minorWorks,
                bookChapters: this.bookChapters,
                journalArticles: this.journalArticles,
                conferenceArticles: this.conferenceArticles,
                technicalReports: this.technicalReports,
                bookEditors: this.bookEditors,
                otherBooks: this.otherBooks
            }

            const candidate = await DataService.saveData(dataDetails);

            if (candidate) {
                if (page == 'previous') {
                    this.$router.push('/sectionb')
                } else if (page == 'next') {
                    //this.$router.push('/sectiond')
                }
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id, 'sectionC');

            if (candidate) { 
                if ((candidate.staffType == "Junior Non-academic") || (candidate.staffType == "Senior Non-academic")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/section1` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.candidate = candidate;
                this.books = candidate.academicStaff.books ? candidate.academicStaff.books : [];
                this.majorWorks = candidate.academicStaff.majorWorks ? candidate.academicStaff.majorWorks : [];
                this.minorWorks = candidate.academicStaff.minorWorks ? candidate.academicStaff.minorWorks : [];
                this.bookChapters = candidate.academicStaff.bookChapters ? candidate.academicStaff.bookChapters : [];
                this.journalArticles = candidate.academicStaff.journalArticles ? candidate.academicStaff.journalArticles : [];
                this.conferenceArticles = candidate.academicStaff.conferenceArticles ? candidate.academicStaff.conferenceArticles : [];
                this.technicalReports = candidate.academicStaff.technicalReports ? candidate.academicStaff.technicalReports : [];
                this.bookEditors = candidate.academicStaff.bookEditors ? candidate.academicStaff.bookEditors : [];
                this.otherBooks = candidate.academicStaff.otherBooks ? candidate.academicStaff.otherBooks : [];
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>
